import { MGPOptional, Utils } from '@everyboard/lib';
import { Player } from '../Player';
import { BoardValue } from './BoardValue';
import { Heuristic } from './Heuristic';
/**
 * Represents possible alignment configurations
 **/
export class AlignmentStatus {
    name;
    // There's no particular alignment
    static NOTHING = new AlignmentStatus('NOTHING');
    // The player could win at this turn
    static PRE_VICTORY = new AlignmentStatus('PRE_VICTORY');
    // The game is finished with a victory
    static VICTORY = new AlignmentStatus('VICTORY');
    constructor(name) {
        this.name = name;
    }
    // Convert to a board value (only for heuristics, will not consider victories)
    toBoardValue(turn) {
        if (this === AlignmentStatus.NOTHING) {
            return BoardValue.of(0);
        }
        else {
            Utils.assert(this === AlignmentStatus.PRE_VICTORY, 'alignment status can only be pre-victory or default');
            const player = Player.of(turn % 2);
            return BoardValue.of(BoardValue.getPreVictoryValueOf(player));
        }
    }
}
export class AlignmentHeuristic extends Heuristic {
    calculateBoardValue(move, state) {
        this.startSearchingVictorySources();
        const boardInfo = {
            status: AlignmentStatus.NOTHING,
            victory: MGPOptional.empty(),
            preVictory: MGPOptional.empty(),
            sum: 0,
        };
        while (this.hasNextVictorySource()) {
            const victorySource = this.getNextVictorySource();
            let newBoardInfo;
            if (boardInfo.status === AlignmentStatus.PRE_VICTORY) {
                newBoardInfo = this.searchVictoryOnly(victorySource, move, state);
            }
            else {
                newBoardInfo = this.getBoardInfo(victorySource, move, state, boardInfo);
            }
            if (newBoardInfo.status === AlignmentStatus.VICTORY) {
                return newBoardInfo;
            }
            boardInfo.status = newBoardInfo.status;
            boardInfo.sum = boardInfo.sum + newBoardInfo.sum;
            if (boardInfo.preVictory.isAbsent()) {
                boardInfo.preVictory = newBoardInfo.preVictory;
            }
        }
        return boardInfo;
    }
}
